import DeleteConfirmModal from './DeleteConfirmModal.vue';

export default DeleteConfirmModal;
